import { render, staticRenderFns } from "./ed-viewer-video-object.component.vue?vue&type=template&id=6209eadb&scoped=true&"
import script from "./ed-viewer-video-object.component.ts?vue&type=script&lang=ts&"
export * from "./ed-viewer-video-object.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-viewer-video-object.component.scss?vue&type=style&index=0&id=6209eadb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6209eadb",
  null
  
)

export default component.exports